import React from 'react';

import { usePatchCard } from '@vlabs/api/artemy/client';
import type { CardId } from '@vlabs/api/artemy/model';
import { EditIcon } from '@vlabs/icons';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';
import { Control, useModal } from '@vlabs/uikit';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { EditCardUserDataForm } from './edit-card-user-data-form/EditCardUserDataForm';

export interface EditCardUserDataButtonProps extends IconButtonProps {
  cardId: CardId;
}

const displayName = 'EditCardUserDataButton';
const testid = buildTestid(displayName);

export function EditCardUserDataButton({
  cardId,
  'data-testid': dataTestId = undefined,
  ...props
}: EditCardUserDataButtonProps): JSX.Element {
  const modal = useModal();
  const { t } = useTranslation();
  const patchCard = usePatchCard({
    mutation: {
      onSuccess: () => {
        toast.success(t('card-page:edit card.toast.success'));
        modal.close();
      },
    },
  });

  return (
    <React.Fragment>
      {modal.wrap(<EditCardUserDataForm
        cardId={cardId}
        onCancel={modal.close}
        onSubmit={(userData) => {
          patchCard.mutate({
            cardId,
            data: { user_data: userData },
          });
        }}
      />)}

      <Control.IconButton
        icon={<EditIcon />}
        kind="secondary"
        onClick={modal.open}
        variant="filled"
        {...testid(dataTestId)}
        {...props}
      />
    </React.Fragment>
  );
}
